var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sim-card-diagnose',{attrs:{"card-id":this.id,"table-type":"sim_card"}})}
var staticRenderFns = []

export { render, staticRenderFns }